// eslint-disable-next-line import/no-extraneous-dependencies
import { StringifiedUUID } from 'quotient/Navigator/types';

enum PARENT_OBJECT_TYPES {
  WORKBOOK = 'workbook',
}

export enum DIRECTORY_LAYER_TYPES {
  CALCULATIONS = 'calculations',
  INPUT = 'input',
}

export enum ENTRY_OBJECT_TYPES {
  WORKSHEET = 'worksheet',
  COMPONENT_INSTANCE = 'component_instance',
  DIRECTORY = 'directory',
}

export enum DIRECTORY_ORDERING_TYPES {
  CUSTOM = 'custom',
  ALPHABETICAL = 'alphabetical',
}

export type BaseEntry = {
  id: StringifiedUUID;
  is_read_only: boolean;
  is_hidden: boolean;
  directory_id: StringifiedUUID;
  root_directory_id: StringifiedUUID;
  parent_object_type: PARENT_OBJECT_TYPES;
  parent_object_id: StringifiedUUID;
  object_type: ENTRY_OBJECT_TYPES;
  object_id: StringifiedUUID;
  created_at: string;
  updated_at: string;
};

export type Directory = BaseEntry & {
  name: string;
  description: string;
  children_order: StringifiedUUID[];
  layer_type: DIRECTORY_LAYER_TYPES;
  ordering_type: DIRECTORY_ORDERING_TYPES;
};

export type Entry = BaseEntry | Directory;
